// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1_vI7","cls2":"QuestionStyles-cls2__Ai QuestionStyles-cls1_vI7"};